import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ageInYears',
})
export class AgeInYearsPipe implements PipeTransform {
  transform(dobString: string): string {
    if (!dobString) {
      return 'non renseigné';
    }
    const dob = new Date(dobString);
    const currentYear = new Date().getFullYear();
    let age = currentYear - dob.getFullYear();

    const currentMonth = new Date().getMonth();
    const currentDay = new Date().getDate();

    if (currentMonth < dob.getMonth() || (currentMonth === dob.getMonth() && currentDay < dob.getDate())) {
      age--;
    }

    return `${age} ans`;
  }
}
